export enum PgnHoverResponsiveArea {
    FILL = "FILL",
    FULL = "FULL",
    STROKE = "STROKE",
    NONE = "NONE"
}
